import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { FacebookIcon, TwitterIcon, InstagramIcon} from './icons'
import { motion } from 'framer-motion'
import { useEase } from './motion'

export const FooterTray = (props) => {

	const footerAnime = {
		closed: {
			x: '-100%',
			transition: {
				ease: useEase('easeOutExpo'),
				duration: 0.5,
			},
		},
		open: {
			x: 0,
			transition: {
				ease: useEase('easeOutExpo'),
				duration: 0.5,
			}
		}
	}

	return (
		<motion.footer
		className='footer-tray'
		variants={footerAnime}
		initial='closed'
		animate={props.footerOpen? 'open' : 'closed' }
		exit='closed'
		>
			<div className='footer-content'>
				<FooterLinks />
				<FooterBrand />
			</div>
		</motion.footer>
	)

}

export const FooterLinks = (props) => {
	return (
		<div className="footer-links">
			<a href="//bu.edu" target="_blank">
				&copy; 2020 Trustees of Boston University
			</a>
			<a
				href="http://www.bu.edu/policies/digital-privacy-statement/"
				target="_blank"
			>
				Privacy Statement
			</a>
			<a href="https://www.bu.edu/disability/" target="_blank">
				Accessibility
			</a>
		</div>
	)
}

export const FooterBrand = (props) => {
	return (
		<div className='footer-brand'>
			<div className='masterplate'></div>
		</div>
	)
}

export const FooterSocial = (props) => {
	return (
		<StaticQuery
			query = { graphql`
				query {
					strapiUtilityNav {
						facebook_url
						twitter_url
						instagram_url
					}
				}
			`}
			render={ data => (
				<nav className='utility-nav'>
					<a href={data.strapiUtilityNav.facebook_url} className='utility-link facebook-icon' target="_blank">
						<FacebookIcon />
					</a>
					<a href={data.strapiUtilityNav.twitter_url} className='utility-link twitter-icon' target="_blank">
						<TwitterIcon />
					</a>
					<a href={data.strapiUtilityNav.instagram_url} className='utility-link instagram-icon' target="_blank">
						<InstagramIcon />
					</a>
				</nav>
			)}
		/>
	)
}